// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Questions__questionsContainer___1Horh{background-color:#122182}.Questions__inner___JEIE7{display:flex;flex-direction:column;padding:40px 24px}@media (min-width:960px){.Questions__inner___JEIE7{padding:80px 24px}}.Questions__title___W_S8v{color:inherit;font-weight:500;font-size:48px;line-height:64px;max-width:700px;margin:0 auto;color:#fff;font-weight:200;line-height:58px;text-align:center}.Questions__list___1RX65{display:grid;grid-gap:40px;grid-template-columns:1fr 1fr;margin-top:56px}@media (max-width:959px){.Questions__list___1RX65{grid-gap:20px;grid-template-columns:1fr;margin-top:40px}}.Questions__item___151-0:not(:first-child){margin-top:48px}@media (min-width:960px){.Questions__item___151-0{flex-basis:calc(50% - 40px)}.Questions__item___151-0:not(:first-child){margin-top:0}}.Questions__itemTitle___37j0C{color:inherit;font-weight:400;font-size:20px;line-height:32px;color:#fff;font-weight:500}.Questions__itemContent___1k_iy{margin-top:16px;color:#d6e3fd}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"questionsContainer": "Questions__questionsContainer___1Horh",
	"inner": "Questions__inner___JEIE7",
	"title": "Questions__title___W_S8v",
	"list": "Questions__list___1RX65",
	"item": "Questions__item___151-0",
	"itemTitle": "Questions__itemTitle___37j0C",
	"itemContent": "Questions__itemContent___1k_iy"
};
module.exports = ___CSS_LOADER_EXPORT___;
